module.exports = __webpack_public_path__ + "img/araya.19662d50.png";